import { createSelector } from 'reselect';
import { State } from '../store';

const usersSelector = (state: State) => state.userStore.users;

const usersByRoleSelector = (role: string) => createSelector(
  usersSelector,
  (users) => users.filter((user) => user.roles.includes(role)),
);

const usersToModerateSelector = (roles: string[]) => createSelector(
  usersSelector,
  (users) => users.filter((user) => user.roles.some((r: string) => roles.includes(r))
  && (!user.is_ban && !user.is_activated)),
);

const usersActiveSelector = (roles: string[]) => createSelector(
  usersSelector,
  (users) => users.filter((user) => user.roles.some((r: string) => roles.includes(r))
  && !user.is_ban && user.is_activated),
);

const usersDisabledSelector = (roles: string[]) => createSelector(
  usersSelector,
  (users) => users.filter((user) => user.roles.some((r: string) => roles.includes(r))
  && user.is_ban),
);

export {
  usersToModerateSelector, usersActiveSelector, usersDisabledSelector, usersByRoleSelector,
};
